import React from "react";

import { useModalContext } from "../../contexts/ModalContext/context";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { usePlacementWorksheetContext } from "../../contexts/PlacementWorksheetContext";
import { useSnackbar } from "../../hooks/useSnackbar";
import useAuth from "../../routes/login/AuthContext";
import { putPlacementWorksheetOccupantsClear } from "../../services/PlacementWorksheetApi";
import { Box } from "../../UI/Box";
import { Button } from "../../UI/Button";
import { Typography } from "../../UI/Typography";
import { Modal } from "../Modal";
import { OpenModalButton } from "../OpenModalButton";
import { usePlacementWorksheetTableRowContext } from "../PlacementWorksheetTable/PlacementWorksheetTableRowContext";

interface IProps {
  unitId: number;
}

export const UnplacedAllResidentsButton: React.FC<IProps> = (props) => {
  const { getAuthToken, isSuperAdminRead } = useAuth();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { setIsOpen } = useModalContext();
  const { l2Id, l3Id, clearUnit } = usePlacementWorksheetContext();
  const [isLoading, setIsLoading] = React.useState(false);
  const { setIsFinished } = usePlacementWorksheetTableRowContext();
  const { showErrorSnackbar } = useSnackbar();

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleSubmit = React.useCallback(async () => {
    if (!l2Id || !l3Id) {
      return;
    }

    setIsLoading(true);

    try {
      const token = await getAuthToken();
      const res = await putPlacementWorksheetOccupantsClear(selectedNetworkId, l2Id, l3Id, [props.unitId], token);
      const { error } = res;
      if (error) {
        throw error;
      }
      clearUnit(props.unitId);
      setIsLoading(false);
      setIsFinished(true);
      closeModal();
    } catch (err) {
      showErrorSnackbar();
      setIsLoading(false);
    }
  }, [selectedNetworkId, l2Id, l3Id, clearUnit]);

  return (
    <OpenModalButton label="Return all to Unplaced" isDisabled={isSuperAdminRead()}>
      <Modal
        maxWidth="sm"
        onClose={closeModal}
        title="Return all residents to Unplaced"
        actions={
          <>
            <Button appearance="subtle" onClick={closeModal} isDisabled={isLoading}>
              Cancel
            </Button>
            <Button appearance="primary" onClick={handleSubmit} isLoading={isLoading}>
              Return all to Unplaced
            </Button>
          </>
        }
      >
        <Box p={3}>
          <Typography>
            By submitting, residents will be moved to the right hand 'Unplaced' area. If they are matched with
            roommates, they will remain with these roommates.
          </Typography>
        </Box>
      </Modal>
    </OpenModalButton>
  );
};
